import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/sagas/leads/leadsManagement";
import { isModuleActive } from "../../../utils/modules";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import ProfilesCreatedMonthToDate from "./smartComponents/profilesCreatedMonthToDate";
import ProfilesCreatedMonthToDateChange from "./smartComponents/profilesCreatedMonthToDateChange";
import PrevProfilesCreatedMonthToDate from "./smartComponents/prevProfilesCreatedMonthToDate";
import ProfilesCreatedYearToDate from "./smartComponents/profilesCreatedYearToDate";
import ProfilesCreatedYearToDateChange from "./smartComponents/profilesCreatedYearToDateChange";
import PrevProfilesCreatedYearToDate from "./smartComponents/prevProfilesCreatedYearToDate";
import YearOverYear from "./smartComponents/yearOverYear";
import LearnMore from "../../../components/learnMore/learnMore";

export class LeadsManagementModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initRequest: false,
      moduleHeight: 600
    };
  }

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Leads Management")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }
    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      const state = configuratorStore.getState();
      if (isModuleActive(state.dashboardConfigurator.preferences, "Leads Management") && !this.state.initRequest) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    // Month switcher store
    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  render() {
    const {learnMoreId, title, content} = this.props.learnMore
    return (
      <SectionToggle
        title="Leads Added"
        learnMore={<LearnMore learnMoreId={learnMoreId} title={title} content={content} html/>}
        customClass="leadmanagementWidget"
        height={this.state.moduleHeight}
        isLoading={this.props.isLoading}
        content={
          <div>
            <div className="section-group">
              <span className="width-50">
                <SectionContainer title="Month To Date">
                  <ProfilesCreatedMonthToDate />
                  <ProfilesCreatedMonthToDateChange />
                </SectionContainer>
              </span>
              <span className="width-50">
                <SectionContainer title="Month to Date this time Last Year">
                  <PrevProfilesCreatedMonthToDate />
                </SectionContainer>
              </span>
            </div>
            <div className="section-group">
              <span className="width-50">
                <SectionContainer title="Year to Date">
                  <ProfilesCreatedYearToDate />
                  <ProfilesCreatedYearToDateChange />
                </SectionContainer>
              </span>
              <span className="width-50">
                <SectionContainer title="Year to Date this time Last Year">
                  <PrevProfilesCreatedYearToDate />
                </SectionContainer>
              </span>
            </div>
            <div className="section-group" style={{ paddingTop: "50px", width: "100%" }}>
              <span className="top">
                <SectionContainer title="Year over Year Comparison">
                  <YearOverYear />
                </SectionContainer>
              </span>
            </div>
          </div>
        }
      />
    );
  }
}

export default connect(
  state => ({
    isLoading: state.leadsManagement.isLoading,
    userParams: state.leadsManagement.currentUser
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(LeadsManagementModule);

LeadsManagementModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  learnMore: PropTypes.objectOf(PropTypes.string)
};
